/* eslint-disable eqeqeq */
import React from 'react';

export const PropertyUsePropertyTypeGroup = ({
  handlePropertyTypeGroup,
  propertyTypeGroupId,
  propertyUseInPropertyTypeGroup,
}) => {
  return (
    <div className="mt-4">
      {propertyUseInPropertyTypeGroup && (
        <label className="h5 mb-2">
          Property Type Group:
        </label>
      )}
      <div className="form-group d-flex flex-wrap align-items-stretch">
        {propertyUseInPropertyTypeGroup &&
          propertyUseInPropertyTypeGroup &&
          React.Children.toArray(
            propertyUseInPropertyTypeGroup?.map(
              (propertyTypeGroup) => (
                <>
                  <div
                    key={propertyTypeGroup?.id}
                    className={`button-belair col-6 mb-0 mt-0 ${
                      propertyTypeGroupId == propertyTypeGroup?.id
                        ? 'blend'
                        : ''
                    }`}
                    onClick={handlePropertyTypeGroup}
                    data-propertytypegroup={propertyTypeGroup?.id}
                  >
                    {propertyTypeGroup?.description}
                  </div>
                </>
              ),
            ),
          )}
      </div>
    </div>
  );
};
